export enum RecipeManagementActionTypes {
    RECIPE_ADD = '@@recipe/RECIPE_ADD',
    RECIPE_ADD_SUCCESS = '@@recipe/RECIPE_ADD_SUCCESS',
    RECIPE_ADD_ERROR = '@@recipe/RECIPE_ADD_ERROR',

    RECIPE_LIST = '@@recipe/RECIPE_LIST',
    RECIPE_LIST_SUCCESS = '@@recipe/RECIPE_LIST_SUCCESS',
    RECIPE_LIST_ERROR = '@@recipe/RECIPE_LIST_ERROR',

    RECIPE_UPDATE = '@@recipe/RECIPE_UPDATE',
    RECIPE_UPDATE_SUCCESS = '@@recipe/RECIPE_UPDATE_SUCCESS',
    RECIPE_UPDATE_ERROR = '@@recipe/RECIPE_UPDATE_ERROR',

    RECIPE_DELETE = '@@recipe/RECIPE_DELETE',
    RECIPE_DELETE_SUCCESS = '@@recipe/RECIPE_DELETE_SUCCESS',
    RECIPE_DELETE_ERROR = '@@recipe/RECIPE_DELETE_ERROR',

    RECIPE_RESET = '@@recipe/RECIPE_RESET',
}
